import { useQuery } from "@tanstack/react-query";
import { getAuth } from "firebase/auth";
import { api } from "@/lib/api-client";

export const getServiceTypes = async (params) => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
        throw new Error("User not authenticated");
    }

    const res = await api.get("/ServiceTypes", {
        params,
    });

    return res.data;
};

export const useServiceTypes = () => {
    return useQuery({
        queryKey: ["serviceTypes"],
        queryFn: getServiceTypes,
        retry: 3,
        staleTime: 1000 * 60,
    });
};
